export default "__VITE_ASSET__Bec1J0$p__"